import { render } from "./TheDigital.vue?vue&type=template&id=c6e3c03e"
import script from "./TheDigital.vue?vue&type=script&lang=js"
export * from "./TheDigital.vue?vue&type=script&lang=js"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__